import {Injectable} from '@angular/core';
import {VineaLocation} from '../../models/vinea-location';
import {ApiImplementation} from '../api/api-implementation.service';
import {ApiService} from '../api/api.service';
import {Paginator} from '../../models/paginator';
import {GroupsService} from '../groups/groups.service';
import {EmployeesService} from '../employees/employees.service';
import {Builder} from '../../models/builder';

@Injectable({
    providedIn: 'root',
})
export class LocationsService extends ApiImplementation {

    protected base: string = 'v1/locations';
    protected primaryKey: string = 'id';

    constructor(
        protected api: ApiService,
        protected employeeService: EmployeesService) {
        super(api)
    }

    model(data?) {
        return new VineaLocation(data);
    }

    paginator(data) {
        return new Paginator<VineaLocation>(data);
    }

    public groups(location: VineaLocation) {
        return this.api.all(this.base + '/' + location.id + '/groups').then(data => {
            return data;
        })
    }

    public groupsActive(location: VineaLocation) {
      return this.api.all(this.base + '/' + location.id + '/groups/active').then(data => {
        return data;
      })
    }

    public employees(location: VineaLocation) {
        return this.api.get(this.base + '/' + location.id + '/employees').then(data => {
            return this.employeeService.transform(data['data']);
        })
    }

    public schedulesAll(location: VineaLocation, builder: Builder = new Builder()) {
        return this.api.all(this.base + '/' + location.id + '/schedules',
          1, [], '&' + builder.buildUrl()
          ).then(data => {
            return data;
        });
    }

    public schedules(location: VineaLocation, builder: Builder = new Builder()) {
        return this.api.get(this.base + '/' + location.id + '/schedules?' + builder.buildUrl()
        ).then(data => {
            return data;
        });
    }

    public all(limit = 100, page = 1): Promise<Paginator<VineaLocation>> {
        return super.all(limit, page) as Promise<Paginator<VineaLocation>>;
    }

    public get(id: number) {
        return super.get(id) as Promise<VineaLocation>;
    }

    public entities(id: number) {
        return this.api.get(this.base + '/' + id + '/entities').then(data => {
            return data['data'];
        });
    }

    public delete(location: VineaLocation) {
        return super.delete(location);
    }

    public save(location: VineaLocation): Promise<VineaLocation> {
        return super.save(location) as Promise<VineaLocation>;
    }

  public everythingActive(builder = new Builder()) {
    return this.api.all(this.base + '/active', 1, [], '&' + builder.buildUrl());
  }
}
